import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { isEmpty } from '../../utils/helper'
import { CustomDescriptionBox } from '../../../components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import Multiselect from 'multiselect-react-dropdown'
import useAxios from 'axios-hooks'
import { AFFILIATES_API } from '../../utils/urls'
import { AppContext } from '../../context/app'

const AffiliatesCreationModal = (props) => {
  const { openModal, onCancel, data, createCallback, updateCallback, roleList } = props
  const [name, setName] = useState('')
  const { setLoader } = useContext(AppContext)
  const [description, setDescription] = useState('')
  const [selectedRoles, setSelectedRoles] = useState([])
  const [password, setPassword] = useState('')
  const [passwordHide, setPasswordHide] = useState(false)
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [code, setCode] = useState('')

  const [errorData, setErrorData] = useState({})

  const editFlag = !isEmpty(data)

  const [{ data: affiliatesData, loading: affiliatesDataLoading }, getAffiliateCall] = useAxios(
    {
      url: AFFILIATES_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    if (!isEmpty(data)) {
      setName(data.name)
      setDescription(data.description)
      setEmail(data.email)
      setMobile(data.mobile)
      setCode(data.code)
      setPassword('tempstr')
      setPasswordHide(true)
      getAffiliateCall({
        params: {
          affiliate_id: data._id,
        },
      })
    }
  }, [data])

  useEffect(() => {
    if (affiliatesData && affiliatesData.success) {
      setSelectedRoles(roleList.filter((obj) => affiliatesData.data.user.roles.includes(obj.id)))
    }
  }, [affiliatesData])

  useEffect(() => {
    setLoader(affiliatesDataLoading)
  }, [affiliatesDataLoading])

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  const handleSelectRoles = (info, type) => {
    if (type === 'add') {
      setSelectedRoles((selectedRoles) => [...selectedRoles, info])
    } else if (type === 'remove') {
      setSelectedRoles((selectedRoles) => selectedRoles.filter((item) => item.id !== info.id))
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}
    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name cannot be Empty!'
    }
    if (code.trim().length === 0) {
      isFormValid = false
      temp.code = 'Code cannot be Empty!'
    }
    if (isEmpty(email)) {
      isFormValid = false
      temp.email = 'Email cannot be Empty!'
    }
    if (isEmpty(password)) {
      isFormValid = false
      temp.password = 'Password cannot be Empty!'
    }
    console.log('selectedRoles', selectedRoles)
    if (isEmpty(selectedRoles)) {
      isFormValid = false
      temp.selectedRoles = 'roles cannot be Empty!'
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = () => {
    if (validateInfo()) {
      let payload = editFlag
        ? {
            name,
            description,
            mobile,
            code,
            user_id: data['user_id'],
            roles: selectedRoles.map((item) => item.id),
          }
        : {
            name,
            description,
            email,
            mobile,
            code,
            password,
            roles: selectedRoles.map((item) => item.id),
          }
      editFlag ? updateCallback(payload, data._id) : createCallback(payload)
    }
  }
  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {editFlag ? `Edit` : `Add`} {'Affiliates'}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol>
              <CFormLabel>Phone</CFormLabel>
              <CFormInput
                type="number"
                value={mobile}
                min="0"
                name="phone"
                onChange={(e) => handleChange(e, setMobile)}
              />
              <div className="message-text error-message">
                <p>{errorData.mobile}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol>
              <CFormLabel>Email*</CFormLabel>
              <CFormInput
                type="email"
                value={email}
                name="email"
                onChange={(e) => handleChange(e, setEmail)}
                disabled={editFlag}
              />
              <div className="message-text error-message">
                <p>{errorData.email}</p>
              </div>
            </CCol>
            <CCol style={{ position: 'relative' }} className="">
              <CFormLabel>Password*</CFormLabel>
              <CFormInput
                type={passwordHide ? 'password' : 'text'}
                value={password}
                name="password"
                onChange={(e) => handleChange(e, setPassword)}
                disabled={editFlag}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '5%',
                  top: errorData.password || errorData.email ? '45%' : '55%',
                }}
              >
                {!passwordHide ? (
                  <FontAwesomeIcon icon={faEye} size="lg" onClick={() => setPasswordHide(true)} />
                ) : (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    size="lg"
                    onClick={() => setPasswordHide(false)}
                  />
                )}
              </div>
              <div className="message-text error-message">
                <p>{errorData.password}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-4">
            <CCol lg={6}>
              <CFormLabel>Affiliate Code*</CFormLabel>
              <CFormInput
                type="text"
                value={code}
                name="Code"
                onChange={(e) => handleChange(e, setCode)}
              />
              <div className="message-text error-message">
                <p>{errorData.code}</p>
              </div>
            </CCol>
          </CRow>

          <CRow className="mt-4">
            <CCol lg="12">
              <CFormLabel>Select Roles*</CFormLabel>
              <Multiselect
                options={roleList} // Options to display in the dropdown
                selectedValues={selectedRoles}
                // color="red"
                style={{
                  chips: {
                    background: 'blue',
                  },
                  searchBox: {
                    background: 'white',
                  },
                }}
                showCheckbox="true"
                onSelect={(e, info) => handleSelectRoles(info, 'add')}
                onRemove={(e, info) => handleSelectRoles(info, 'remove')}
                displayValue="name"
              />
              <div className="message-text error-message">
                <p>{errorData.selectedRoles}</p>
              </div>
            </CCol>
          </CRow>
          <div className="mt-3">
            <CustomDescriptionBox
              title="Description"
              rows={2}
              value={description}
              onChange={setDescription}
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleCreate}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AffiliatesCreationModal
